import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Typography, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Stack, Button, Chip } from '@mui/material';
import { FaEnvelope } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { fetchAllNewsletters } from '../../controllers/newsletterController';
import { resolveNewsletterAssetUrl } from '../../api/httpClientNewsletter';
import EditNewsletterDialog from '../../components/EditNewsletterDialog';
import ImageIcon from '@mui/icons-material/Image';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const Bültenler = () => {
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [editOpen, setEditOpen] = useState(false);
    const [selectedNewsletterId, setSelectedNewsletterId] = useState(null);

    useEffect(() => {
        let active = true;
        setLoading(true);
        setError('');
        fetchAllNewsletters({ pageNumber: 1, pageSize: 6 })
            .then(({ data }) => {
                if (!active) return;
                setItems(Array.isArray(data) ? data : []);
            })
            .catch((e) => {
                if (active) setError(e?.message || 'Bültenler alınamadı');
            })
            .finally(() => {
                if (active) setLoading(false);
            });
        return () => {
            active = false;
        };
    }, []);

    const handleEditOpen = (newsletter) => {
        setSelectedNewsletterId(newsletter.id);
        setEditOpen(true);
    };

    const handleEditClose = () => {
        setEditOpen(false);
        setSelectedNewsletterId(null);
        fetchAllNewsletters({ pageNumber: 1, pageSize: 5 })
            .then(({ data }) => {
                setItems(Array.isArray(data) ? data : []);
            })
            .catch((e) => {
                setError(e?.message || 'Bültenler alınamadı');
            });
    };

    const handleEditSuccess = () => {
        fetchAllNewsletters({ pageNumber: 1, pageSize: 5 })
            .then(({ data }) => {
                setItems(Array.isArray(data) ? data : []);
            })
            .catch((e) => {
                setError(e?.message || 'Bültenler alınamadı');
            });
    };

    return (
        <>
            <Card sx={{ flex: '0 0 calc(50% - 16px)', minWidth: 300, border: '1px solid #f1f1f1', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)', borderRadius: '8px' }}>
                <CardContent sx={{ p: 2.5 }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
                        <Stack direction="row" alignItems="center" spacing={1.5}>
                            <Box
                                sx={{
                                    width: 44,
                                    height: 44,
                                    borderRadius: '50%',
                                    backgroundColor: '#f5f5f5',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <FaEnvelope style={{ fontSize: '18px', color: '#0E4D94' }} />
                            </Box>
                            <Typography sx={{ fontSize: '18px', fontWeight: 500, color: '#444444' }}>
                                Son Bültenler
                            </Typography>
                        </Stack>
                        <Button
                            variant="text"
                            size="small"
                            onClick={() => navigate('/newsletters')}
                            sx={{
                                textTransform: 'none',
                                fontSize: '13px',
                                fontWeight: 500,
                                backgroundColor: 'transparent',
                                color: '#0E4D94',
                                textDecoration: 'underline',
                                '&:hover': {
                                    backgroundColor: 'transparent',
                                    textDecoration: 'underline',
                                },
                            }}
                        >
                            Tüm Bültenler
                        </Button>
                    </Stack>

                    {error ? (
                        <Typography color="error" sx={{ fontSize: '14px' }}>{error}</Typography>
                    ) : loading ? (
                        <TableContainer>
                            <Table size="small">
                                <TableHead sx={{ bgcolor: 'transparent' }}>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: 500, borderBottom: '1px dashed #e8e8e8', px: 1.5, py: 1.5, color: '#a3a3a3' }}>Görsel</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: 500, borderBottom: '1px dashed #e8e8e8', px: 1.5, py: 1.5, color: '#a3a3a3' }}>Başlık</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: 500, borderBottom: '1px dashed #e8e8e8', px: 1.5, py: 1.5, color: '#a3a3a3' }}>Durum</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Array.from({ length: 5 }).map((_, index) => (
                                        <TableRow
                                            key={`skeleton-${index}`}
                                            sx={{
                                                '& .MuiTableCell-root': {
                                                    borderBottom: index === 4 ? 'none' : '1px dashed #e8e8e8',
                                                    px: 1.5,
                                                    py: 1.5,
                                                },
                                            }}
                                        >
                                            <TableCell>
                                                <Skeleton width={50} height={50} borderRadius={4} />
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton width={200} height={20} />
                                            </TableCell>
                                            <TableCell>
                                                <Skeleton width={70} height={24} borderRadius={16} />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : items.length === 0 ? (
                        <Typography sx={{ fontSize: '14px', color: '#a3a3a3', textAlign: 'center', py: 2 }}>
                            Henüz bülten bulunmamaktadır.
                        </Typography>
                    ) : (
                        <TableContainer>
                            <Table size="small">
                                <TableHead sx={{ bgcolor: 'transparent' }}>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: 500, borderBottom: '1px dashed #e8e8e8', px: 1.5, py: 1.5, color: '#a3a3a3' }}>Görsel</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: 500, borderBottom: '1px dashed #e8e8e8', px: 1.5, py: 1.5, color: '#a3a3a3' }}>Başlık</TableCell>
                                        <TableCell sx={{ fontSize: '14px', fontWeight: 500, borderBottom: '1px dashed #e8e8e8', px: 1.5, py: 1.5, color: '#a3a3a3' }}>Durum</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {items.map((item, index) => (
                                        <TableRow
                                            key={item.id}
                                            hover
                                            onClick={() => handleEditOpen(item)}
                                            sx={{
                                                cursor: 'pointer',
                                                '& .MuiTableCell-root': {
                                                    borderBottom: index === items.length - 1 ? 'none' : '1px dashed #e8e8e8',
                                                    px: 1.5,
                                                    py: 1.5,
                                                    color: '#444444',
                                                    fontWeight: 500,
                                                },
                                            }}
                                        >
                                            <TableCell>
                                                {item.coverImageUrl ? (
                                                    <Box
                                                        component="img"
                                                        src={resolveNewsletterAssetUrl(item.coverImageUrl)}
                                                        alt={item.title}
                                                        sx={{
                                                            width: 50,
                                                            height: 50,
                                                            objectFit: 'cover',
                                                            borderRadius: '4px',
                                                        }}
                                                    />
                                                ) : (
                                                    <Box
                                                        sx={{
                                                            width: 50,
                                                            height: 50,
                                                            borderRadius: '4px',
                                                            backgroundColor: '#f5f5f5',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                        }}
                                                    >
                                                        <ImageIcon sx={{ fontSize: 24, color: '#a3a3a3' }} />
                                                    </Box>
                                                )}
                                            </TableCell>
                                            <TableCell>{item.title}</TableCell>
                                            <TableCell>
                                                <Chip
                                                    label={item.isActive ? 'Aktif' : 'Pasif'}
                                                    size="small"
                                                    sx={{
                                                        backgroundColor: item.isActive ? '#DFFFEA' : '#FFEEF3',
                                                        color: item.isActive ? '#17C653' : '#F8285A',
                                                        fontWeight: 600,
                                                        fontSize: '12px'
                                                    }}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </CardContent>
            </Card>
            <EditNewsletterDialog
                open={editOpen}
                onClose={handleEditClose}
                newsletterId={selectedNewsletterId}
                onSuccess={handleEditSuccess}
            />
        </>
    );
};

export default Bültenler;
